import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgentService, AuthService } from '@services';
import { MatDialog } from '@angular/material/dialog';
import {
  QuickAnswersDialogComponent,
  AutomationsDialogComponent,
} from '../dialogs';
import { Router } from '@angular/router';
import { AppRoutes } from '@constants';
import { Status, StatusTypes } from '@interfaces';

@Component({
  selector: 'unicon-avatar-box',
  templateUrl: './avatar-box.component.html',
})
export class AvatarBoxComponent implements OnInit {
  protected initials: string = '';
  protected statusTypes: StatusTypes[] = [];
  protected statusType: number = 0;
  protected showAutomations: boolean = false;
  @Input() fullname?: string;
  @Input() description?: string;
  @Input() loading: boolean = true;
  @Input() session: boolean = false;
  @Input() status?: number;
  @Output() valueEmit = new EventEmitter<number>();

  constructor(
    private authService: AuthService,
    private agentService: AgentService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.setBadgeText();
    this.getStatusTypes();
    this.checkAutomationsVisibility();
    //this.statusType = this.status
  }

  private checkAutomationsVisibility(): void {
    const session = this.authService.getSessionValues();
    this.showAutomations =
      session?.leadArchiveTimeoutHours !== null &&
      session?.leadArchiveTimeoutHours !== undefined;
  }

  private setBadgeText(): void {
    if (this.fullname) {
      const slices: string[] = this.fullname.split(' ');
      this.initials = slices[0][0] + (slices[1] ? slices[1][0] : '');
    }
  }

  protected onLogout(): void {
    this.authService.logout();
  }

  protected onAnswersClick(): void {
    this.dialog.open(QuickAnswersDialogComponent, {
      disableClose: false,
      autoFocus: false,
      width: 'auto',
      height: 'auto',
      panelClass: 'quick-answers-dialog',
    });
  }

  protected onArchivesClick(): void {
    this.router.navigate([
      `/${AppRoutes.COMMERTIAL}/${AppRoutes.LEADS}/${AppRoutes.ARCHIVED_LEADS}`,
    ]);
  }

  protected onAutomationsClick(): void {
    this.dialog.open(AutomationsDialogComponent, {
      disableClose: false,
      autoFocus: false,
      width: 'auto',
      height: 'auto',
      panelClass: 'automations-dialog',
    });
  }

  protected getStatusTypes(): void {
    this.agentService.getStatus().subscribe({
      next: (statusTypes: StatusTypes[]) => {
        this.statusTypes = statusTypes;
      },
    });
  }

  protected updatedStatus(request: Status): void {
    this.agentService.updateStatus(request).subscribe({
      next: () => {
        this.status = request.statusId;
        this.valueEmit.emit(this.status);
      },
    });
  }

  protected onChangeStatus(event: Event) {
    event.stopPropagation();
    const status = event.target as HTMLInputElement;
    const valueStatus = status.value;
    const request: Status = {
      statusId: Number(valueStatus),
    };
    this.updatedStatus(request);
  }
}
